module.exports = {"sorry":"Lo sentimos, algo ha salido mal.","tryagain":"Volver a cargar"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/PageError/localization/es-ES/strings.json
// module id = 1176
// module chunks = 0